import React from 'react';

interface PromoIconProps {
  width?: string;
  height?: string;
  alt?: string;
  className?: string;
  color?: string;
}

const PromoIcon: React.FC<PromoIconProps> = ({
  width = '16px',
  height = '16px',
  alt = 'This listing has a special promotion - contact for details',
  className,
  color = '#005952',
}) => (
  <svg
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    width={width}
    height={height}
    role="img"
    aria-label={alt}
    className={className}
  >
    <path d="M15 5.709c.551 0 1 .448 1 1v1.058a.99.99 0 01-.891.977v6.133c0 .62-.633 1.123-1.41 1.123H2.3c-.777 0-1.41-.504-1.41-1.123V8.744A.99.99 0 010 7.767V6.709c0-.552.449-1 1-1h1.738c-.454-.214-.828-.504-1.075-.886-.393-.608-1.22-2.658.084-4.07.64-.658 1.387-.89 2.168-.675C5.71.575 7.202 3.306 7.45 3.945h.804C8.503 3.305 9.991.577 11.79.078c.778-.215 1.529.017 2.163.67 1.31 1.417.482 3.467.09 4.075-.249.382-.621.672-1.075.886H15zM5.877 7.95h4.246V6.424H5.877v1.527zm9.407-.184V6.709A.284.284 0 0015 6.425h-4.16v1.626H15c.154 0 .284-.13.284-.284zm-1.585 7.516c.396 0 .693-.214.693-.406v-6.11H10.48v6.516h3.22zm-7.395 0h3.458V8.767H6.304v6.516zm-4.003 0h3.286V8.767H1.608v6.11c0 .192.297.406.693.406zM.716 7.767c0 .154.13.284.284.284h4.16V6.425H1a.284.284 0 00-.284.284v1.058zM5.55 4.246c-.121-.186-.294-.38-.525-.479-.182-.076-.28-.09-.325-.09-.02 0-.03.003-.033.004a.87.87 0 00.14.447c.129.176.417.217.743.118zm-3.284.187c.57.881 2.021 1.174 3.983.808l.087.468h.067a1.099 1.099 0 01-.168-.558c0-.17.032-.325.086-.468l-.102.056a2.119 2.119 0 01-1 .278c-.41 0-.765-.158-.99-.465-.268-.366-.381-.981-.097-1.337.165-.205.502-.392 1.171-.107.576.245.902.775 1.074 1.175l.077.18c.085-.127.187-.23.31-.313-.216-.529-1.621-3.04-3.09-3.394-.507-.12-.967.039-1.406.492-.997 1.078-.243 2.814-.002 3.185zm7.892-.187c.327.1.615.058.744-.118.11-.153.142-.395.114-.465-.004.013-.097.005-.333.104-.232.1-.404.293-.525.479zm1.876-3.49c-1.372.33-2.687 2.54-3.032 3.264.134.046.252.117.357.207.177-.393.493-.885 1.043-1.118.674-.289 1.008-.1 1.173.105.285.357.172.972-.095 1.338-.226.307-.582.465-.992.465-.242 0-.506-.073-.771-.184.019.082.05.16.05.246 0 .074-.027.134-.037.203 1.823.29 3.17-.01 3.712-.849.24-.371.994-2.107-.008-3.192-.432-.447-.89-.61-1.4-.485zM9.05 5.15c0-.302-.188-.49-.419-.49H7.368a.418.418 0 00-.418.418c0 .302.187.49.418.49H8.63c.23 0 .419-.188.419-.418z" />
  </svg>
);

export default PromoIcon;
